import {Operation} from "@echope/echope-store-core/dist/util";

export const operationFrom = (item: any): Operation => {
    const { type, message, error } = item;
    return new Operation(type, message, error);
}